import axios from "axios";
import { queryClient } from "../config/queryClient";

export type AdministrativeAreasResponse = {
  page: number;
  totalPages: number;
  totalElements: number;
  values: string[];
};

export const getAddressData = async (locale: string, areas: string[] = []) =>
  await queryClient.fetchQuery({
    queryKey: [locale, areas],
    queryFn: async (): Promise<AdministrativeAreasResponse> =>
      await avsApi.getAdministrativeAreas(locale, areas, 0, 2000),
    staleTime: Infinity,
    gcTime: Infinity,
  });

const getAdministrativeAreas = async (
  locale: string,
  areas: string[],
  page: number,
  size: number
): Promise<AdministrativeAreasResponse> => {
  const areasParam =
    areas.length > 0 ? `areas=${encodeURIComponent(areas.join("|"))}&` : "";
  const url = `/v1/administrative-areas/${locale}?${areasParam}page=${page}&size=${size}`;

  const response = await axios.get<AdministrativeAreasResponse>(url);
  return response.data;
};

export const avsApi = {
  getAdministrativeAreas,
};
